import { plainToClass } from 'class-transformer';
import { forEach } from 'lodash';
import { FileUpload } from './file-upload';
import { ProjectForm, ProjectFormHub, ProjectFormRevision, CombinedProjectForm, ProjectFile, UserEmailListing } from './project-form.entities';
import { GetSelectedDate, GetSelectedDropdownValues, InitializeDateSelector, InitializeFilterDropdown } from "../../../shared/scripts/filtering/filtering.utilities";



export class ProjectFormPage {
    newFormId: number;
    combinedForm: CombinedProjectForm;
    newForm: boolean;
    currentFormId: number;
    isAdmin: boolean;
    FileUploadAims: FileUpload;
    FileUploadDescription: FileUpload;
    FileUploadBudget: FileUpload;
    CurrentFileAims: ProjectFile[];
    CurrentFileDescription: ProjectFile[];
    CurrentFileBudget: ProjectFile[];
    users: UserEmailListing[];
    userEmails: any[];
    userEmail: string;
    POemail: string;
    SOemail: string;
    FormNameEmail: string;
    HasBeenSOApproved: boolean;


    constructor(newFormId: number, combinedFormJSON: any, isAdmin: boolean, CurrentFileAims: any, CurrentFileDescription: any, CurrentFileBudget: any, userEmail: string, isSO: boolean, isPO: boolean, directoryJson: any) {
        this.newFormId = newFormId;
        this.newForm = true;
        this.HasBeenSOApproved = false;
        this.isAdmin = isAdmin;
        this.userEmail = userEmail;
        this.CurrentFileAims = plainToClass(ProjectFile, <ProjectFile[]>CurrentFileAims);
        this.CurrentFileDescription = plainToClass(ProjectFile, <ProjectFile[]>CurrentFileDescription);
        this.CurrentFileBudget = plainToClass(ProjectFile, <ProjectFile[]>CurrentFileBudget);
        this.initializeFileUploads();

        this.POemail = "candace.webb@nih.gov;";
        this.SOemail = "angela.lee-winn@nih.gov;";


        this.users = plainToClass(UserEmailListing, <UserEmailListing[]>directoryJson);
        this.userEmails = [];
        this.users = this.users.map((user: UserEmailListing) => {
            user.initialize();
            this.userEmails.push({ value: user.Email, label: user.FirstName + " " + user.LastName });
            return user;
        });


        this.userEmails.sort((a,b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

        const emailSelect = document.getElementById("email-select") as HTMLSelectElement;
        emailSelect.innerHTML = "";
        this.userEmails.forEach(email => {
            const option = document.createElement("option");
            option.value = email.value;
            option.text = email.label;
            emailSelect.appendChild(option);
        });

        //break this out into a populate form function
        if (combinedFormJSON != "0") {
            let statusId = 0;
            let allowEdit = false;
            this.newForm = false;
            this.combinedForm = plainToClass(CombinedProjectForm, <CombinedProjectForm>combinedFormJSON);
            this.currentFormId = this.combinedForm.ProjectForm.FormId;
            statusId = this.combinedForm.ProjectForm.StatusId;
            this.FormNameEmail = this.combinedForm.ProjectForm.Email;

            if (this.combinedForm.ProjectForm.Description == "True") {
                this.HasBeenSOApproved = true;
            }
            //if you are not an admin type user and the form is in draft or revision requested status, you can edit the form
            //OR
            //if you are an admin type user and the project form was submitted by you and is in draft or revision requested status, you can edit the form
            if ((!(isAdmin || isSO || isPO) && (statusId == 0 || statusId == 2)) || ((isAdmin || isSO || isPO) && userEmail == this.combinedForm.ProjectForm.Email && (statusId == 0 || statusId == 2))) allowEdit = true;

            if (this.combinedForm.Hubs.length > 2) {
                for (let i = 2; i < this.combinedForm.Hubs.length; i++) {
                    this.addHubInput();
                }
            }

            const hubSelects = document.getElementsByClassName("hub");
            const budgetSelects = document.getElementsByClassName("budget");
            for (let i = 0; i < hubSelects.length; i++) {
                let currentHub = hubSelects[i] as HTMLSelectElement;
                let currentBudget = budgetSelects[i] as HTMLInputElement;
                currentHub.value = this.combinedForm.Hubs[i].HubId.toString();
                currentBudget.value = this.combinedForm.Hubs[i].Budget.toLocaleString();
                if (!allowEdit) {
                    currentHub.disabled = true;
                    currentBudget.disabled = true;
                }
            }
            const startDateInput = document.getElementById("start-date") as HTMLInputElement;
            startDateInput.value = this.combinedForm.ProjectForm.StartDate.split("T")[0];
            const endDateInput = document.getElementById("end-date") as HTMLInputElement;
            endDateInput.value = this.combinedForm.ProjectForm.EndDate.split("T")[0];

            //const aimsInput = document.getElementById("research-aims") as HTMLInputElement;
            //aimsInput.value = this.combinedForm.ProjectForm.Aims;
            //const descriptionInput = document.getElementById("research-plan") as HTMLInputElement;
            //descriptionInput.value = this.combinedForm.ProjectForm.Description;
            const stakeholderEngagementInput = document.getElementById("stakeholder-engagement") as HTMLInputElement;
            stakeholderEngagementInput.value = this.combinedForm.ProjectForm.StakeholderEngagement;
            const title = document.getElementById("project-title") as HTMLInputElement;
            title.value = this.combinedForm.ProjectForm.Title;


            const InteractInvolved = document.getElementById("interact-involvement") as HTMLInputElement;
            InteractInvolved.checked = this.combinedForm.ProjectForm.InteractInvolved;

            const InteractDetails = document.getElementById("interact-detail-text") as HTMLTextAreaElement;
            InteractDetails.value = this.combinedForm.ProjectForm.InteractDetails;
            if (this.combinedForm.ProjectForm.InteractInvolved) this.toggleInteractDetails();
            const selectedEmails = this.combinedForm.ProjectForm.Aims.split(";");

            $('.selectpicker').selectpicker('val', selectedEmails);


            if (!allowEdit) {
                InteractInvolved.disabled = true;
                startDateInput.disabled = true;
                endDateInput.disabled = true;
                //aimsInput.disabled = true;
                //descriptionInput.disabled = true;
                InteractDetails.disabled = true;
                stakeholderEngagementInput.disabled = true;
                emailSelect.disabled = true;

                this.showFileDownloads();



                document.getElementById("add-hub").classList.add("d-none");
                document.getElementById("remove-hub").classList.add("d-none");
                document.getElementsByClassName("submit")[0].classList.add("d-none");
                document.getElementsByClassName("save")[0].classList.add("d-none");
                document.getElementsByClassName("close-btn")[0].classList.remove("d-none");
            }

            this.handleRevisions();
            if ((isAdmin || isSO || isPO) && this.combinedForm.ProjectForm.Email != userEmail) {
                document.getElementsByClassName("submit")[0].classList.add("d-none");
                document.getElementsByClassName("save")[0].classList.add("d-none");
                document.getElementsByClassName("approve")[0].classList.add("d-none");
                document.getElementsByClassName("deny")[0].classList.add("d-none");
                document.getElementsByClassName("request")[0].classList.add("d-none");
                //if (!(statusId == 0 || (statusId == 1 && !isSO) || statusId == 2 || (statusId == 3 && !isPO) || statusId == 4 || statusId == 5)) {
                if ((statusId == 1 && isSO) || (statusId == 3 && isPO)) {
                    document.getElementsByClassName("close-btn")[0].classList.add("d-none");
                    document.getElementsByClassName("approve")[0].classList.remove("d-none");
                    document.getElementsByClassName("deny")[0].classList.remove("d-none");
                    document.getElementsByClassName("request")[0].classList.remove("d-none");
                }
            }
            else if ((isAdmin || isSO || isPO) && this.combinedForm.ProjectForm.Email == userEmail) {
                document.getElementsByClassName("approve")[0].classList.add("d-none");
                document.getElementsByClassName("deny")[0].classList.add("d-none");
                document.getElementsByClassName("request")[0].classList.add("d-none");
            }

        }
        else {
            if (isAdmin || isSO || isPO) {
                document.getElementsByClassName("approve")[0].classList.add("d-none");
                document.getElementsByClassName("deny")[0].classList.add("d-none");
                document.getElementsByClassName("request")[0].classList.add("d-none");
            }
        }
        this.updateTotalBudget();
        this.setupCharacterCounter();
        const budgetSelects = document.getElementsByClassName("budget");
        for (let i = 0; i < budgetSelects.length; i++) {
            let currentBudget = budgetSelects[i] as HTMLInputElement;
            currentBudget.addEventListener("keyup", (event) => {
                this.updateTotalBudget();
                const budget = event.target as HTMLInputElement;
                if (isNaN(parseInt(budget.value.replace(/,/g, "")))) budget.value = "0";
                budget.value = parseInt(budget.value.replace(/,/g, "")).toLocaleString();
            });
        }


        $(() => {
            $(".next").click((event) => {
                if (this.isHubInfoValid()) {
                    this.nextSection($(event.currentTarget)); // '$(event.currentTarget)' references the clicked element
                }
            });

            $(".prev").click((event) => {
                this.previousSection($(event.currentTarget)); // '$(event.currentTarget)' references the clicked element
            });
        });


        const interactDetails = document.getElementById("interact-detail-text") as HTMLTextAreaElement;
        const wordCountDisplay = document.getElementById("word-count") as HTMLElement;
        const maxWords = 250;

        interactDetails.addEventListener("input", () => {
            this.updateWordCount();
        });
        this.updateWordCount();
    }

    updateWordCount() {
        const interactDetails = document.getElementById("interact-detail-text") as HTMLTextAreaElement;
        const wordCountDisplay = document.getElementById("word-count") as HTMLElement;
        const maxWords = 250;

        const words = interactDetails.value.trim().split(/\s+/).filter(word => word.length > 0);
        const wordCount = words.length;

        if (wordCount > maxWords) {
            interactDetails.value = words.slice(0, maxWords).join(' ');
            wordCountDisplay.innerText = `0`;
        } else {
            wordCountDisplay.innerText = `${maxWords - wordCount}`;
        }
    }

    initializeFileUploads(): void {
        this.FileUploadAims = new FileUpload("#aims-file-upload-block", () => {

            // prepopulate    
            if (this.CurrentFileAims) {
                this.FileUploadAims.uploadedFiles = this.CurrentFileAims;
                this.FileUploadAims.drawGallery();
            }
        });
        this.FileUploadDescription = new FileUpload("#description-file-upload-block", () => {

            // prepopulate    
            if (this.CurrentFileDescription) {
                this.FileUploadDescription.uploadedFiles = this.CurrentFileDescription;
                this.FileUploadDescription.drawGallery();
            }
        });
        this.FileUploadBudget = new FileUpload("#budget-justification-file-upload-block", () => {

            // prepopulate    
            if (this.CurrentFileBudget) {
                this.FileUploadBudget.uploadedFiles = this.CurrentFileBudget;
                this.FileUploadBudget.drawGallery();
            }
        });
    }

    updateTotalBudget(): void {
        const total = document.getElementById("total") as HTMLElement;
        const budgetSelects = document.getElementsByClassName("budget");
        let sum = 0;
        for (let i = 0; i < budgetSelects.length; i++) {
            let currentBudget = budgetSelects[i] as HTMLInputElement;
            if (!isNaN(parseInt(currentBudget.value.replace(/,/g, "")))) sum += parseInt(currentBudget.value.replace(/,/g, ""));
            else sum += 0;
        }
        total.innerText = sum.toLocaleString();
    }

    nextSection(currentSection: any): void {
        let currentSectionElement = currentSection.parent().parent();
        let newSection = currentSectionElement.next();

        currentSectionElement.toggleClass("inactive-section");
        currentSectionElement.toggleClass("active-section");
        newSection.toggleClass("inactive-section");
        newSection.toggleClass("active-section");
    }

    previousSection(currentSection: any): void {
        let currentSectionElement = currentSection.parent().parent();
        let newSection = currentSectionElement.prev();

        currentSectionElement.toggleClass("inactive-section");
        currentSectionElement.toggleClass("active-section");
        newSection.toggleClass("inactive-section");
        newSection.toggleClass("active-section");
    }

    submitForm(type: string): void {
        if (!this.isProjectInfoValid(type)) {
            return;
        }
        this.uploadFiles();
        let projectForm = new ProjectForm();
        if (this.newForm) projectForm.FormId = this.newFormId;
        else projectForm.FormId = this.currentFormId;
        if (type == "draft") projectForm.StatusId = 0;
        else if (type == "submit") projectForm.StatusId = 1;
        else if (type == "revision requested") projectForm.StatusId = 2;
        else if (type == "approveSO") projectForm.StatusId = 3;
        else if (type == "approvePO") projectForm.StatusId = 5;
        else if (type == "deny") projectForm.StatusId = 4;
        projectForm.SubmissionDate = new Date().toISOString().split("T")[0];

        const startDateInput = document.getElementById("start-date") as HTMLInputElement;
        projectForm.StartDate = startDateInput.value;
        const endDateInput = document.getElementById("end-date") as HTMLInputElement;
        projectForm.EndDate = endDateInput.value;

        //deprecated now that we are using file upload but repurposed to store emails
        let emails = GetSelectedDropdownValues("#email-select");
        if (this.newForm) {
            emails.push(this.userEmail.split("|")[0]);
            this.FormNameEmail = this.userEmail;
        }
        else {
            emails.push(this.FormNameEmail.split("|")[0]);
        }
        //POs
        

        projectForm.Aims = "";
        for (let i = 0; i < emails.length; i++) {
            projectForm.Aims = projectForm.Aims + emails[i] + ";";
        }

        projectForm.Description = "";

        const stakeholderEngagementInput = document.getElementById("stakeholder-engagement") as HTMLInputElement;
        projectForm.StakeholderEngagement = stakeholderEngagementInput.value;
        const title = document.getElementById("project-title") as HTMLInputElement;
        projectForm.Title = title.value;
        const InteractInvolved = document.getElementById("interact-involvement") as HTMLInputElement;
        projectForm.InteractInvolved = InteractInvolved.checked;
        const InteractDetails = document.getElementById("interact-detail-text") as HTMLTextAreaElement;
        projectForm.InteractDetails = InteractDetails.value;

        //storing hubs
        let hubs = [];

        const hubSelections = document.querySelectorAll('.hub');
        const budgetSelections = document.querySelectorAll('.budget');

        for (let i = 0; i < hubSelections.length; i++) {
            let projectFormHub = new ProjectFormHub();
            let currentHub = hubSelections[i] as HTMLInputElement;
            projectFormHub.FormId = projectForm.FormId;
            projectFormHub.HubId = parseInt(currentHub.value);
            if (currentHub.id.includes("lead")) projectFormHub.HubTypeId = 1;
            else projectFormHub.HubTypeId = 2;
            let currentBudget = budgetSelections[i] as HTMLInputElement;
            projectFormHub.Budget = parseInt(currentBudget.value.replace(/,/g, ""));
            hubs.push(projectFormHub);
        }

        let combinedForm = new CombinedProjectForm();
        combinedForm.ProjectForm = projectForm;
        combinedForm.Hubs = hubs;


        if (this.newForm) combinedForm.Revisions = [];
        else {
            combinedForm.Revisions = this.combinedForm.Revisions;
        }
        if (type == "revision requested") {
            let revision = new ProjectFormRevision();
            const revisionInput = document.getElementById("revision-request") as HTMLInputElement;
            revision.Reason = revisionInput.value;
            revision.FormId = projectForm.FormId;
            revision.RequestDate = new Date().toISOString().split("T")[0];
            revision.StatusId = 2;
            combinedForm.Revisions.push(revision);
            $("#revisionModal").modal("hide");
        }
        //Determine if first SO approval
        if (projectForm.StatusId == 3 && !this.HasBeenSOApproved) {
            projectForm.Description = "True";
        }


        this.updateFormDatabase(combinedForm);

        this.sendEmail(projectForm, !this.HasBeenSOApproved, projectForm.Title);

        document.getElementById("hub-info").style.display = "none";
        document.getElementById("project-info").style.display = "none";
        document.getElementById("spinner").classList.remove("d-none");

        setTimeout(() => window.location.href = "/secure/project-form/project-form-dashboard", 5000); 
    }

    sendEmail(projectForm: ProjectForm, isFirstSOApproval: boolean, title: string): void {

        let emails = projectForm.Aims;
        let statusId = projectForm.StatusId;
        let formId = projectForm.FormId;
        let submitter = this.FormNameEmail.split("|")[1];
        let cc = this.SOemail + this.POemail + "connect-ehe@rti.org";

        let url = 'https://connect-research.org/secure/project-form/project-form?formId=' + formId;

        let DisplayId = formId.toString();
        for (let i = DisplayId.length; i < 3; i++) {
            DisplayId = "0" + DisplayId;
        }
        DisplayId = "P" + DisplayId;

        let body = ``;
        let subject = ``;
        if (statusId == 1 && this.newForm) {
            subject = `CONNECT Joint Proposal ` + DisplayId + `: Submission Confirmation `;

            body += `Dear ` + submitter + `,`;
            body += `</br>`;
            body += `</br>`;
            body += `We have received your joint research proposal, ` + DisplayId + `: ` + title + `. Your proposal is currently under review with the NIDA Science Officer (SO). The SO will contact you within three weeks to provide feedback and request any needed revisions to the proposal. Revised proposals should be resubmitted through the <a href="${url}">CONNECT Portal</a>.`;
            body += `</br>`;
            body += `</br>`;
            body += `You will receive an email confirmation when the SO has approved your submission. Once the SO approves the submission, the authorized representative for each participating hub should send the proposal to the NIDA Program Officer (PO) through the Grants Management System requesting permission to release funds being held for joint projects.`;
            body += `</br>`;
            body += `</br>`;
            body += `If you have any questions about the status of your proposal, please email <a class="nowrap" href="mailto:connect-ehe@rti.org">connect-ehe@rti.org</a>.`;
            body += `</br>`;
            body += `</br>`;
            body += `Sincerely,`;
            body += `</br>`;
            body += `The CONNECT EngageData Center `;
            this.sendSOApprovalEmail(DisplayId, url, title);
        }
        else if (statusId == 2) {
            subject = `CONNECT Joint Proposal ` + DisplayId + `: Revision Requested`;

            body += `Dear ` + submitter + `,`;
            body += `</br>`;
            body += `</br>`;
            body += `The NIDA Science Officer (SO) has reviewed and provided feedback for your proposal, ` + DisplayId + `: ` + title + `. Please review the feedback and requested revisions for your submission by <a href="${url}">clicking here</a>.</br></br>Please submit the revised proposal through the CONNECT Portal within two weeks.`;
            body += `</br>`;
            body += `</br>`;
            body += `You will receive an email confirmation when the revised submission is received, and you will receive an email notification when the SO has approved the revised submission. If you have any questions about the status of your proposal, please email <a class="nowrap" href="mailto:connect-ehe@rti.org">connect-ehe@rti.org</a>.`;
            body += `</br>`;
            body += `</br>`;
            body += `Sincerely,`;
            body += `</br>`;
            body += `The CONNECT EngageData Center `;

        }
        else if (statusId == 1 && !this.newForm) { //revision was requested and the submission was edditted and resubmitted
            subject = `CONNECT Joint Proposal ` + DisplayId + `: Revision Received`;

            body += `Dear ` + submitter + `,`;
            body += `</br>`;
            body += `</br>`;
            body += `We have received your revised joint research proposal, ` + DisplayId + `: ` + title + `. Your proposal is currently under review with the NIDA Science Officer (SO). <i>Your request is not yet approved.</i> `;
            body += `</br>`;
            body += `</br>`;
            body += `If additional revisions are needed, the SO will contact you by email within two weeks. Otherwise, you will receive an email confirmation approving your submission. Once the SO approves the submission, the authorized representative for each participating hub should send the proposal to the NIDA Program Officer (PO) through the Grants Management System requesting permission to release funds being held for joint projects.`;
            body += `</br>`;
            body += `</br>`;
            body += `If you have any questions about the status of your proposal, please email <a class="nowrap" href="mailto:connect-ehe@rti.org">connect-ehe@rti.org</a>.`;
            body += `</br>`;
            body += `</br>`;
            body += `Sincerely,`;
            body += `</br>`;
            body += `The CONNECT EngageData Center `;

            this.sendSORevisionEmail(DisplayId, url, title);
        }
        if (statusId == 3) {
            subject = `CONNECT Joint Proposal ` + DisplayId + `: SO Approval`;

            body += `Dear ` + submitter + `,`;
            body += `</br>`;
            body += `</br>`;
            body += `Your proposal, ` + DisplayId + `: ` + title + `, is approved by the NIDA Science Officer. The authorized representative for each participating hub must now send the proposal to the NIDA Program Officer (PO) through the Grants Management System (GMS) requesting permission to release funds being held for joint projects. <i>Work on joint projects cannot begin until you receive confirmation of PO approval.</i>`;
            body += `</br>`;
            body += `</br>`;
            body += `The GMS submission is the final step in the proposal review process and may take up to three weeks to process.`;
            body += `</br>`;
            body += `</br>`;
            body += `If you have any questions about this process, please email <a class="nowrap" href="mailto:connect-ehe@rti.org">connect-ehe@rti.org</a>.`;
            body += `</br>`;
            body += `</br>`;
            body += `Sincerely,`;
            body += `</br>`;
            body += `The CONNECT EngageData Center `;

            if (isFirstSOApproval) {
                this.sendGTMSEmail(DisplayId, url, title);
            }
        }
        if (statusId == 5) {
            subject = `CONNECT Joint Proposal ` + DisplayId + `: Proposal Approved`;

            body += `Dear ` + submitter + `,`;
            body += `</br>`;
            body += `</br>`;
            body += `Congratulations! Your proposal, ` + DisplayId + `: ` + title + `, is approved and you may proceed with your joint research activities.`;
            body += `</br>`;
            body += `</br>`;
            body += `If you have any questions about this process, please email <a class="nowrap" href="mailto:connect-ehe@rti.org">connect-ehe@rti.org</a>.`;
            body += `</br>`;
            body += `</br>`;
            body += `Sincerely,`;
            body += `</br>`;
            body += `The CONNECT EngageData Center `;
        }
        this.sendApprovalEmail(emails, cc, body, subject);
    }

    sendSOApprovalEmail(DisplayId: string, url: string, title: string): void {
        let body = ``;

        body += `Dear Angela Lee-Winn,`;
        body += `</br>`;
        body += `</br>`;
        body += `A new joint research proposal, ` + DisplayId + `: ` + title + `, has been submitted for review in the CONNECT Portal. Please <a href="${url}">click here</a> to access the proposal. `;
        body += `</br>`;
        body += `</br>`;
        body += `<i>Next steps:</i>`;
        body += `</br>`;
        body += `<ul><li>Review the joint proposal, including the aims, research plan, timeline, and methods.</li><li>Within the CONNECT Portal, provide feedback, request revisions, or approve the submission.  Please complete this step within three weeks of receiving this email.</li></ul>`;
        body += `</br>`;
        body += `</br>`;
        body += `Sincerely,`;
        body += `</br>`;
        body += `The CONNECT EngageData Center `;

        this.sendApprovalEmail(this.SOemail, this.POemail + "connect-ehe@rti.org", body, "New CONNECT Proposal: SO Review");
    }

    sendSORevisionEmail(DisplayId: string, url: string, title: string): void {
        let body = ``;

        body += `Dear Angela Lee-Winn,`;
        body += `</br>`;
        body += `</br>`;
        body += `A revised joint research proposal, ` + DisplayId + `: ` + title + `, has been submitted for your approval. Please <a href="${url}">click here</a> to review and approve the request.`;
        body += `</br>`;
        body += `</br>`;
        body += `Sincerely,`;
        body += `</br>`;
        body += `The CONNECT EngageData Center `;

        this.sendApprovalEmail(this.SOemail, this.POemail + "connect-ehe@rti.org", body, "Revised CONNECT Proposal for SO Review");
    }

    sendGTMSEmail(DisplayId: string, url: string, title: string): void {
        let body = ``;

        body += `Dear Candace Webb,`;
        body += `</br>`;
        body += `</br>`;
        body += `The Scientific Officer has approved a new joint research proposal, ` + DisplayId + `: ` + title + `, and the lead authors have been instructed to submit their proposal to request funds through the Grants Management System.`;
        body += `</br>`;
        body += `</br>`;
        body += `Next steps: Once the GMS request is approved, please also approve the submission <a href="${url}">here</a> on the CONNECT Portal. Your approval in the CONNECT Portal will notify the submitter of project approval so they may begin joint research activities.`;
        body += `</br>`;
        body += `</br>`;
        body += `Sincerely,`;
        body += `</br>`;
        body += `The CONNECT EngageData Center `;

        this.sendApprovalEmail(this.POemail, this.SOemail + "connect-ehe@rti.org", body, "CONNECT Joint Proposal Needs Approval");
    }

    sendApprovalEmail(email: string, cc: string, body: string, subject: string, onSuccessFn: Function = (response: any) => { console.log("success"); }, onErrorFn: Function = (response: any) => { console.log(response); }): void {
        //console.log(email);
        $.ajax({
            url: '/secure/project-form/project-form?handler=SendEmail',
            method: "POST",
            //dataType: "json",
            //contentType: "application/json",
            data: { email: JSON.stringify(email), cc: JSON.stringify(cc), body: JSON.stringify(body), subject: JSON.stringify(subject) },
            headers: {
                "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string
            },
            success: (response) => {
                onSuccessFn(response);
            },
            error: (response) => {
                onErrorFn(response);
            }
        });
    }


    updateFormDatabase(formInfo: CombinedProjectForm, onSuccessFn: Function = (response: any) => { console.log("success"); }, onErrorFn: Function = (response: any) => { console.log(response); }): void {        
        $.ajax({
            url: '/secure/project-form/project-form?handler=SaveCombinedProjectForm',
            method: "POST",
            //dataType: "json",
            //contentType: "application/json",
            data: { formData: JSON.stringify(formInfo) },
            headers: {
                "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string
            },
            success: (response) => {
                onSuccessFn(response);
            },
            error: (response) => {
                onErrorFn(response);
            }
        });
    }

    uploadFiles(): void {
        // Handle File Upload
        if (this.FileUploadAims.shouldUpdateFiles) {
            let formData: FormData = new FormData();

            let files: File[] = this.FileUploadAims.files;

            let id = this.newForm ? this.newFormId : this.currentFormId;

            for (var i = 0; i < files.length; i++) {
                let key: string = id.toString() + "/" + files[i].name;
                formData.append(key, files[i]);
            }

            let excludedfilesArr = [];
            this.FileUploadAims.uploadedFiles.forEach(file => excludedfilesArr.push(file.id));
            let excludedfilestring = excludedfilesArr.join("|");

            $.ajax({
                url: '/secure/project-form/project-form?handler=UploadFilesAims',
                method: "POST",
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string, "FormId": id.toString(), "ExcludedFiles": excludedfilestring },
                success: (response) => {
                    this.FileUploadAims.shouldUpdateFiles = false;
                },
                error: (response) => {
                    console.log("error", response);
                }
            });
        }
        else {
            console.log("no files to upload");
            //return;
            /*isFileUploadComplete = true;*/
        }

        if (this.FileUploadDescription.shouldUpdateFiles) {
            let formData: FormData = new FormData();

            let files: File[] = this.FileUploadDescription.files;
            let id = this.newForm ? this.newFormId : this.currentFormId;
            for (var i = 0; i < files.length; i++) {
                let key: string = id.toString() + "/" + files[i].name;
                formData.append(key, files[i]);
            }

            let excludedfilesArr = [];
            this.FileUploadDescription.uploadedFiles.forEach(file => excludedfilesArr.push(file.id));
            let excludedfilestring = excludedfilesArr.join("|");

            $.ajax({
                url: '/secure/project-form/project-form?handler=UploadFilesDescription',
                method: "POST",
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string, "FormId": id.toString(), "ExcludedFiles": excludedfilestring },
                success: (response) => {
                    this.FileUploadDescription.shouldUpdateFiles = false;
                },
                error: (response) => {
                    console.log("error", response);
                }
            });
        }
        else {
            console.log("no files to upload");
            //return;
            /*isFileUploadComplete = true;*/
        }

        if (this.FileUploadBudget.shouldUpdateFiles) {
            let formData: FormData = new FormData();

            let files: File[] = this.FileUploadBudget.files;
            let id = this.newForm ? this.newFormId : this.currentFormId;
            for (var i = 0; i < files.length; i++) {
                let key: string = id.toString() + "/" + files[i].name;
                formData.append(key, files[i]);
            }

            let excludedfilesArr = [];
            this.FileUploadBudget.uploadedFiles.forEach(file => excludedfilesArr.push(file.id));
            let excludedfilestring = excludedfilesArr.join("|");

            $.ajax({
                url: '/secure/project-form/project-form?handler=UploadFilesBudget',
                method: "POST",
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string, "FormId": id.toString(), "ExcludedFiles": excludedfilestring },
                success: (response) => {
                    this.FileUploadBudget.shouldUpdateFiles = false;
                },
                error: (response) => {
                    console.log("error", response);
                }
            });
        }
        else {
            console.log("no files to upload");
            //return;
            /*isFileUploadComplete = true;*/
        }
    }

    addHubInput(): void {
        const rows = document.getElementsByClassName("hub-row");
        const currentRow = rows[rows.length - 1] as HTMLElement;
        const newRow = currentRow.cloneNode(true) as HTMLElement;
        currentRow.insertAdjacentElement("afterend", newRow);


        const hubSelects = document.getElementsByClassName("hub");
        const budgetSelects = document.getElementsByClassName("budget");
        const lastHub = hubSelects[hubSelects.length - 1] as HTMLSelectElement;
        const lastBudget = budgetSelects[budgetSelects.length - 1] as HTMLInputElement;
        lastHub.value = "";
        lastBudget.value = "";
        $(lastHub as HTMLElement).siblings(".error-msg")?.hide();
        $(lastBudget as HTMLElement).siblings(".error-msg")?.hide();


        lastBudget.addEventListener("keyup", (event) => {
            this.updateTotalBudget();
            const budget = event.target as HTMLInputElement;
            if (isNaN(parseInt(budget.value.replace(/,/g, "")))) budget.value = "0";
            budget.value = parseInt(budget.value.replace(/,/g, "")).toLocaleString();
        });
    }

    removeHubInput(): void {
        const rows = document.getElementsByClassName("hub-row");
        const currentRow = rows[rows.length - 1] as HTMLElement;
        if (rows.length > 1) currentRow.remove();
    }

    returnToDashboard(): void {
        window.location.href = "/secure/project-form/project-form-dashboard";
    }


    handleRevisions(): void {
        let revisions = [];
        if (this.combinedForm.Revisions.length > 0) {
            revisions = this.combinedForm.Revisions;
            let revisionReason = revisions[revisions.length - 1].Reason;
            const revisionInput = document.getElementById("revision-request") as HTMLInputElement;
            revisionInput.value = revisionReason;
            revisionInput.disabled = true;
            $("#revisionModal").modal("show");
            document.getElementsByClassName("revision-submit")[0].classList.add("d-none");
            document.getElementsByClassName("revision-cont")[0].classList.remove("d-none");
        }
    }


    closeRevisionModal(): void {
        $("#revisionModal").modal("hide");
    }

    openRevisionModal(): void {
        $("#revisionModal").modal("show");
        const revisionInput = document.getElementById("revision-request") as HTMLInputElement;
        revisionInput.value = "";
        revisionInput.disabled = false;
        const maxLength = revisionInput.maxLength;
        document.getElementsByClassName("revision-submit")[0].classList.remove("d-none");
        document.getElementsByClassName("revision-cont")[0].classList.add("d-none");
        const revisionCharCount = document.getElementById("revision-character-count") as HTMLElement;
        revisionCharCount.textContent = `${maxLength} characters remaining`;
    }

    setupCharacterCounter(): void {
        const textAreas = document.getElementsByClassName('character-textarea');
        const charCounts = document.getElementsByClassName('char-count');
        for (let i = 0; i < textAreas.length; i++) {
            const textArea = textAreas[i] as HTMLTextAreaElement;
            const charCount = charCounts[i] as HTMLElement;
            const maxLength = textArea.maxLength;
            const remaining = maxLength - textArea.value.length;
            charCount.textContent = `${remaining} characters remaining`;
            textArea.addEventListener('input', () => {
                const maxLength = textArea.maxLength;
                const remaining = maxLength - textArea.value.length;
                charCount.textContent = `${remaining} characters remaining`;
                if (remaining === 0) {
                    textArea.classList.add("error");
                } else {
                    textArea.classList.remove("error");
                }
            });
        }
    }

    isHubInfoValid(): boolean {
        let fields = $("input, select").filter("[required]:visible");
        fields.map(function () {
            // check and see if required values are blank
            let inputValue = $(this).val()
            // show error message if the required fields are left blank
            if (inputValue == "" || inputValue == null || inputValue == "0") {
                $(this).siblings(".error-msg")?.show();
                //$(this).addClass("is-invalid");
                if($(this).hasClass("budget")){
                    $(this).parent(".usd-input").siblings(".error-msg")?.show();
                }
            }
            // hide any visible error messages if the required fields are completed
            else {
                $(this).siblings(".error-msg")?.hide();
                //$(this).removeClass("is-invalid");
                //$(this).addClass("is-valid");
                if ($(this).hasClass("budget")) {
                    $(this).parent(".usd-input").siblings(".error-msg")?.hide();
                }
            }
        })
        let errorMsgs = $(".error-msg").filter(":visible");
        if (errorMsgs.length > 0) {
            return false;
        }
        else {
            // if no errors, remove the validation classes
            //allFields.map(function () {
            //    $(this).removeClass("is-invalid");
            //    $(this).removeClass("is-valid");
            //})
            return true;
        }
    }

    isProjectInfoValid(formSubmissionType: string): boolean {
        let fields = $("textarea").filter("[required]:visible").not(".revision-text")
        if (formSubmissionType == "draft") return true;
        if (formSubmissionType == "revision requested") {
            fields = $("textarea").filter("[required]:visible")
        }
        fields.map(function () {
            // check and see if required values are blank
            let inputValue = $(this).val()
            // show error message if the required fields are left blank
            if (inputValue == "" || inputValue == null) {
                $(this).siblings(".error-msg")?.show();
                //$(this).addClass("is-invalid");
            }
            // hide any visible error messages if the required fields are completed
            else {
                $(this).siblings(".error-msg")?.hide();
                //$(this).removeClass("is-invalid");
                //$(this).addClass("is-valid");
            }
        })
        fields = $("div").filter("[required]:visible");
        let aimsUploaded = true;
        let descriptionUploaded = true;
        let budgetUploaded = true;
        if (this.FileUploadAims.files.length < 1 && this.FileUploadAims.uploadedFiles.length < 1) {
            aimsUploaded = false;
        }
        if (this.FileUploadDescription.files.length < 1 && this.FileUploadDescription.uploadedFiles.length < 1) {
            descriptionUploaded = false;
        }
        if (this.FileUploadBudget.files.length < 1 && this.FileUploadBudget.uploadedFiles.length < 1) {
            budgetUploaded = false;
        }
        fields.map(function () {
            if (!descriptionUploaded && this.id == "description-container") {
                $(this).siblings(".error-msg")?.show();
            }
            else if (descriptionUploaded && this.id == "description-container") {
                $(this).siblings(".error-msg")?.hide();
            }

            if (!aimsUploaded && this.id == "aims-container") {
                $(this).siblings(".error-msg")?.show();
            }
            else if (aimsUploaded && this.id == "aims-container") {
                $(this).siblings(".error-msg")?.hide();
            }

            if (!budgetUploaded && this.id == "budget-justification-container") {
                $(this).siblings(".error-msg")?.show();
            }
            else if (budgetUploaded && this.id == "budget-justification-container") {
                $(this).siblings(".error-msg")?.hide();
            }
        })
        // check to see if there are any error messages present
        let errorMsgs = $(".error-msg").filter(":visible");
        //console.log(errorMsgs.length);
        // if errors are present, scroll to the top of the section
        if (errorMsgs.length > 0) {
            return false;
        }
        else {
            // if no errors, remove the validation classes
            //allFields.map(function () {
            //    $(this).removeClass("is-invalid");
            //    $(this).removeClass("is-valid");
            //})
            return true;
        }

    }

    toggleInteractDetails() {
        const detailsRow = document.getElementById("interact-details") as HTMLElement;
        if (detailsRow.classList.contains("d-none")) {
            detailsRow.classList.remove("d-none");
        }
        else {
            detailsRow.classList.add("d-none");
        }
    }

    showFileDownloads() {
        const aimsContainer = document.getElementById("aims-container") as HTMLElement;
        aimsContainer.classList.add("d-none");

        const descContainer = document.getElementById("description-container") as HTMLElement;
        descContainer.classList.add("d-none");

        const budgetContainer = document.getElementById("budget-justification-container") as HTMLElement;
        budgetContainer.classList.add("d-none");

        let content = "";
        for (let i = 0; i < this.CurrentFileAims.length; i++) {
            if (this.CurrentFileAims[i] == undefined || this.CurrentFileAims[i] == null) continue;

            let icon = this.CurrentFileAims[i].icon;

            content +=
                `<label class="label-title required">Research Aims (page limit: 1):</label>
                <div class="card">
                    <div class="row justify-content-between">
                        <div class="col-md-12">
                            <div class="header-text" style="margin-left: 15px;">
                                <a class="text-decoration-none d-flex align-items-center" href="${this.CurrentFileAims[i].link}" target="_blank">
                                    <i class="${icon} expand-btn"></i><span class="expand-text d-block pl-2 no-pointer">${this.CurrentFileAims[i].text}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>`
        }

        const aimsFileDownloads = document.getElementById("aims-file-downloads") as HTMLElement;
        aimsFileDownloads.innerHTML = content;

        content = "";

        for (let i = 0; i < this.CurrentFileDescription.length; i++) {
            if (this.CurrentFileDescription[i] == undefined || this.CurrentFileDescription[i] == null) continue;

            let icon = this.CurrentFileDescription[i].icon;

            content +=
                `<label class="label-title required">Brief Description of Research Plan (to include, as applicable, research methods, data to be collected, proposed data sets, proposed partners, sample size, recruitment strategy, analysis plan) (page limit: 3):</label>
                <div class="card">
                    <div class="row justify-content-between">
                        <div class="col-md-12">
                            <div class="header-text" style="margin-left: 15px;">
                                <a class="text-decoration-none d-flex align-items-center" href="${this.CurrentFileDescription[i].link}" target="_blank">
                                    <i class="${icon} expand-btn"></i><span class="expand-text d-block pl-2 no-pointer">${this.CurrentFileDescription[i].text}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>`
        }

        const descFileDownloads = document.getElementById("description-file-downloads") as HTMLElement;
        descFileDownloads.innerHTML = content;

        content = "";

        for (let i = 0; i < this.CurrentFileBudget.length; i++) {
            if (this.CurrentFileBudget[i] == undefined || this.CurrentFileBudget[i] == null) continue;

            let icon = this.CurrentFileBudget[i].icon;

            content +=
                `<label class="label-title required">Budget Justification</label>
                <div class="card">
                    <div class="row justify-content-between">
                        <div class="col-md-12">
                            <div class="header-text" style="margin-left: 15px;">
                                <a class="text-decoration-none d-flex align-items-center" href="${this.CurrentFileBudget[i].link}" target="_blank">
                                    <i class="${icon} expand-btn"></i><span class="expand-text d-block pl-2 no-pointer">${this.CurrentFileBudget[i].text}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>`
        }

        const budgetFileDownloads = document.getElementById("budget-justification-file-downloads") as HTMLElement;
        descFileDownloads.innerHTML = content;
    }
}